import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

import { theme } from '../../themes/theme'
import { DRAG_HANDLE, PAPER, PANEL_BORDER, POPOVER_SHADOW } from '../styles/colors'
import { BoldMedBodyText, BoldSmallBodyText } from '../styles/Text'

export const fileDragGhostStrings = {
  extraCount: count => `+${count}`
}

const Ghost = styled.div`
  position: relative;
  display: inline-block;
`

const Card = styled.div`
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${PAPER};
  border: 1.5px solid ${theme.colors.primary};
  border-radius: 10px;
  box-shadow: ${POPOVER_SHADOW};
  white-space: nowrap;

  .MuiSvgIcon-root {
    font-size: 18px;
    color: ${DRAG_HANDLE};
  }
`

const StackedCard = styled.div`
  position: absolute;
  z-index: 0;
  left: 8px;
  right: 8px;
  top: 7px;
  bottom: -6px;
  background: ${PAPER};
  border: 1px solid ${PANEL_BORDER};
  border-radius: 10px;
  box-shadow: ${POPOVER_SHADOW};
`

const CountBadge = styled(BoldSmallBodyText)`
  padding: 1px 9px;
  background: ${theme.colors.primary};
  border-radius: 999px;
  color: ${PAPER};
`

// The floating card shown under the cursor while dragging table rows. When more
// than one file is lifted it grows a +N badge and a stacked card peeking out behind.
function FileDragGhost({ filename, count = 1 }) {
  return (
    <Ghost>
      {count > 1 && <StackedCard data-testid="drag-ghost-stack" />}
      <Card>
        <DragIndicatorIcon />
        <BoldMedBodyText>{filename}</BoldMedBodyText>
        {count > 1 && <CountBadge data-testid="drag-ghost-count">{fileDragGhostStrings.extraCount(count - 1)}</CountBadge>}
      </Card>
    </Ghost>
  )
}

FileDragGhost.propTypes = {
  filename: PropTypes.string.isRequired,
  count: PropTypes.number
}

export default FileDragGhost
